import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

import { GENDER_MAP, PayerId } from "~/common/constants";
import { isAdditionalAlignersCourse, isPowerCapCourse, isRetainersCourse } from "~/common/courses";
import { FormatDate } from "~/components/common/FormatDate";
import { PersonName } from "~/components/common/PersonName";
import ProbablyFormattedMessage from "~/components/probably_formatted_message";
import { LabelledValue } from "~/components/ui/labelled-value";
import type { TPatient } from "~/types/patient";

export function PatientCardPatientInfo({ patient }: { patient: TPatient }) {
  return (
    <div>
      <h3 className="block" id="patient-info-label">
        <FormattedMessage id="BLOCKHEAD_PAT_INFO" />
      </h3>

      {isAdditionalAlignersCourse(patient.course.course_id) ? (
        <LabelledValue label={<FormattedMessage id="pat_table.name" />}>
          <Link to={`/pages/patient/${patient.original_patient?.patient_id}`}>
            <PersonName person={patient} />
          </Link>
        </LabelledValue>
      ) : (
        <LabelledValue label={<FormattedMessage id="pat_table.name" />}>
          <PersonName person={patient} />
        </LabelledValue>
      )}

      {isAdditionalAlignersCourse(patient.course.course_id) ? null : (
        <LabelledValue label={<FormattedMessage id="HEADER_SEX" />}>
          <ProbablyFormattedMessage id={patient.sex ? GENDER_MAP[patient.sex] : undefined} />
        </LabelledValue>
      )}

      {isAdditionalAlignersCourse(patient.course.course_id) ? null : (
        <LabelledValue label={<FormattedMessage id="HEADER_BDATE" />}>
          {patient.bdate ? (
            <FormatDate value={patient.bdate} date />
          ) : (
            <FormattedMessage id="None" />
          )}
        </LabelledValue>
      )}

      {patient.payer_id == PayerId.PATIENT ? (
        <LabelledValue label={<FormattedMessage id="PAT_EMAIL" />}>
          {patient.email ? patient.email : <FormattedMessage id="None" />}
        </LabelledValue>
      ) : null}

      {isRetainersCourse(patient.course.course_id) ||
      isAdditionalAlignersCourse(patient.course.course_id) ||
      isPowerCapCourse(patient.course.course_id) ? null : (
        <LabelledValue label={<FormattedMessage id="HEADER_CONDITION" />}>
          <span className="tw-whitespace-pre-wrap">
            {patient.diagnosis || <FormattedMessage id="None" />}
          </span>
        </LabelledValue>
      )}
    </div>
  );
}
